import Vue from 'vue'
// 引用axios
import axios from 'axios'
import Qs from 'qs'
import conf from '../../static/config/index.json'

axios.get('./static/config/index.json').then(r => {
  // console.log(r.data)
  localStorage.setItem('configs', JSON.stringify(r.data))
}).catch(err => {
  console.log('配置文件获取失败', err)
})

let config = JSON.parse(localStorage.getItem('configs'))
// console.log(config)

// 配置API接口地址
var apiRoot = config ? config.baseApi : conf.baseApi
var payApiRoot = config ? config.payApi : conf.payApi
var loginApiRoot = config ? config.loginApi : conf.loginApi
// var apiRoot = conf.baseApi
// var payApiRoot = conf.payApi
// var loginApiRoot = conf.loginApi

// console.log(apiRoot)
// 自定义判断元素类型JS
function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull (o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

function useApi (method, url, params, success, failure, qs) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'DELETE' || method === 'PUT' ? qs === 'qs' ? Qs.stringify(params) : params : null,
    params: method === 'GET' ? params : null,
    baseURL: apiRoot,
    withCredentials: false
  })
    .then(function (res) {
      if (res.status === 200) {
        if (res.data.code === 200 || res.data.state === 200 || (!res.data.code && !res.data.state)) {
          if (success) {
            success(res.data)
          }
        } else {
          if (failure) {
            failure(res.data)
          } else {
            console.log('error: ' + JSON.stringify(res.data))
            // window.alert('error: ' + JSON.stringify(res.data))
          }
        }
      } else {
        if (failure) {
          failure(res.status)
        } else {
          console.log('error: ' + JSON.stringify(res.data))
          // window.alert('error: ' + JSON.stringify(res.data))
        }
      }
    })
    .catch(function (err) {
      if (err.error) {
        Vue.$vux.toast.text(err.error_description, 'middle')
      } else {
        console.log('api error, HTTP CODE: ' + err)
        // window.alert('api error, HTTP CODE: ' + err)
      }
    })
}

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return useApi('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure, qs) {
    return useApi('POST', url, params, success, failure, qs)
  },
  put: function (url, params, success, failure, qs) {
    return useApi('PUT', url, params, success, failure, qs)
  },
  delete: function (url, params, success, failure) {
    return useApi('DELETE', url, params, success, failure)
  },
  payApi: payApiRoot,
  loginApi: loginApiRoot
  // transApi: transApiRoot
}



// WEBPACK FOOTER //
// ./src/api/index.js